// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tbt7u","productName":"Table_productName__23ZAx"};